import React from 'react';
import logoSvg from '../../assets/dalaride-square-gradient.svg';
import logoDefaultSvg from '../../assets/dalaride-default.svg';

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
  onClick?: () => void;
  variant?: 'square' | 'default';
}

export const Logo: React.FC<LogoProps> = ({
  className = '',
  width = 40,
  height = 17,
  onClick,
  variant = 'square',
}) => {
  let logoSrc;
  switch (variant) {
    case 'square':
      logoSrc = logoSvg;
      break;
    default:
      logoSrc = logoDefaultSvg;
  }

  return (
    <img
      src={logoSrc}
      alt="Dala Rides Logo"
      width={width}
      height={height}
      className={`${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
    />
  );
};

export default Logo;
